import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabView } from './tab-view/tab-view';



@NgModule({
  declarations: [
    TabView
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TabView,
  ]
})
export class TabViewModule { }
